import { ClientTypeEnum } from "~~/enums/clientTypeEnum";
import { useAuthStore } from "~~/store/auth";

export default defineNuxtRouteMiddleware(async (to, from) => {
	const auth = useAuthStore();
    if(process.client) {
        if(!auth.isAuthenticated() && to.path !== '/minha-area/login') {
            return window.location.href = '/minha-area/login';
        }

        const canBeAbleAccessAdmin = (auth.isAdmin() || auth.isAttendant());

        if(!canBeAbleAccessAdmin && to.path.startsWith('/admin')) {
            return navigateTo('/minha-area/pedidos');
        }
    }
  })